export default __webpack_public_path__ + "static/media/brick-icon.e9894c95.svg";